import { Check } from "lucide-react";
import { PALETTES, type Appearance, type AppearanceMode } from "./appearance";

const MODES: { id: AppearanceMode; label: string }[] = [
  { id: "light", label: "淺色" }, { id: "dark", label: "深色" }, { id: "system", label: "跟隨系統" },
];
export function AppearanceControls({ value, onChange }: { value: Appearance; onChange: (appearance: Appearance) => void }) {
  return <section className="appearance-controls" aria-labelledby="appearance-heading">
    <h3 id="appearance-heading">閱讀外觀</h3>
    <div className="appearance-modes" role="group" aria-label="明暗模式">{MODES.map(mode =>
      <button key={mode.id} aria-pressed={value.mode === mode.id} onClick={() => onChange({ ...value, mode: mode.id })}>{mode.label}</button>
    )}</div>
    <div className="appearance-presets" role="group" aria-label="閱讀色系">{PALETTES.map(palette =>
      <button key={palette.id} aria-pressed={value.palette === palette.id} onClick={() => onChange({ palette: palette.id, mode: palette.id === "ink" ? "dark" : palette.id === "paper" ? "light" : value.mode })}>
        <span className="appearance-swatch" style={{ background: palette.background }} aria-hidden="true"><i style={{ background: palette.accent }} /></span>
        <span className="appearance-name">{palette.name}</span><Check size={16} aria-hidden="true" className="appearance-check" />
      </button>
    )}</div>
    <p>色系與明暗只儲存在此裝置，不影響學習記錄。義戰保留原有卡牌色彩與文字標記。</p>
  </section>;
}
